






























import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import MapResolver from '../../util/MapResolver';
import TiandituPanel from '@/views/search/TiandituPanel.vue';
import BaiduPanel from '@/views/search/BaiduPanel.vue';
import { mapServer } from '../../../src/api/installService';
import publishObjectPath from '@/util/configRegistry';
@Component({
    name: 'Advertisement',
    components : {},
    mixins: [MapResolver],
})
export default class Advertisement extends Vue {
  private img_list: any = [];
  private data_list: any = [];
  private show: any = false;
  private detailShow: any = false;
  private detailData: any = {
    attachmenturl: '',
    attachmentList: [],
  };
  private upLoadPath: any = publishObjectPath.value.upLoadPath;
  private close() {
    this.show = false;
    this.detailShow = false;
  }
  private detailclose() {
    this.detailShow = false;
  }
  private mounted() {
    mapServer.getAdList({
      endDate: '',
      nowPage: 1,
      pageSize: 5,
      startDate: '',
      stateFlag: '',
      title: '',
      source: 1,
    }).then((res: any) => {
      if (res.data.status === 200) {
        if (res.data.data.length > 0) {
          this.show = true;
          res.data.data.map((item: any) => {
            this.img_list.push(this.upLoadPath + item.attachmentPath);
            this.data_list.push(item);
          });
          this.img_list = this.img_list.slice(0, 3);
          this.data_list = this.data_list.slice(0, 3);
        }
      }
    });
  }
  private showdetail(da: any) {

    mapServer.getAdById({
      adsenseId: this.data_list[da].referId,
    }).then((res: any) => {
      if (res.data.status === 200) {
        this.detailData = res.data.data;
        this.detailData.attachmenturl = res.data.data.attachmentList[0].url;
        this.detailShow = true;
      }
    });
  }
}
